import axios from 'axios'
import Cookies from 'js-cookie'
import useSWR from 'swr'

import { API_PARAMS } from '../../../config/consts'
import { formatDateToStr } from '../../../utils/display'

interface GetStoreVisitCountRequest {
  serviceId: string
  siteId?: string | null
  floorId?: string | null
  siteGroupId?: string | null
  fromDate: Date | null // '2021-01-01'
  toDate: Date | null // '2021-01-02'
}

interface GetStoreVisitCountResponse {
  statusCode: number
  statusMessage: string
  currentPeriodValue: number
  previousPeriodValue: number
  storeVisitCountDatas: {
    date: string
    value: number
  }[]
}

const useGetStoreVisitCount = ({
  serviceId,
  siteId,
  floorId,
  siteGroupId,
  fromDate,
  toDate,
}: GetStoreVisitCountRequest) => {
  const accessToken = Cookies.get('LoginToken')
  const fetcher = (url: string): Promise<GetStoreVisitCountResponse> => axios.get(url).then((res) => res.data)

  const url = new URL(`${process.env.REACT_APP_CITRUS_API_DOMAIN}/api/getStoreVisitCount`)
  url.searchParams.append('accessToken', accessToken ?? '')
  url.searchParams.append('serviceId', serviceId)
  if (siteGroupId && siteGroupId !== '') {
    url.searchParams.append('siteGroupId', siteGroupId)
  } else if (floorId && floorId !== API_PARAMS.SELECT_ALL) {
    url.searchParams.append('floorId', floorId)
  } else {
    url.searchParams.append('siteId', siteId ?? API_PARAMS.SELECT_ALL)
  }
  url.searchParams.append('fromDate', formatDateToStr(fromDate))
  url.searchParams.append('toDate', formatDateToStr(toDate))

  const { data, isLoading, mutate } = useSWR(
    () => accessToken && serviceId && fromDate && toDate && url.href,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
    },
  )
  return {
    storeVisitCount: data,
    storeVisitCountLoading: isLoading,
    storeVisitCountMutate: mutate,
  }
}

export default useGetStoreVisitCount
